import React, { useState } from "react";
import { Modal } from "@/components/Modal";
import { ABtn } from "@/components/games/arcadeUi";
import { sfx } from "@/lib/soundfx";

const PACKS = [
  { k: "chips", l: "Chips Packet", e: "🍟" },
  { k: "gum", l: "Big Babol", e: "🫧" },
  { k: "kurkure", l: "Kurkure", e: "🌽" },
];
const GIFTS = [
  { e: "🃏", n: "WWF Tazo", r: "Common" },
  { e: "🏏", n: "Sachin Cricket Card", r: "Rare" },
  { e: "💫", n: "Glow Tattoo", r: "Common" },
  { e: "🐉", n: "Pokémon Tazo", r: "Rare" },
  { e: "🎴", n: "WWF Sticker", r: "Common" },
  { e: "🥤", n: "Pepsi Bottle Cap", r: "Common" },
  { e: "⭐", n: "Shaktimaan Card", r: "Epic" },
];
const KEY = "kirana_gifts";
const load = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
const save = (arr) => { try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) { /* ignore */ } };

export const LuckyPack = ({ open, onClose }) => {
  const [reveal, setReveal] = useState(null);
  const [collected, setCollected] = useState(load);
  if (!open) return null;

  const openPack = () => {
    const g = GIFTS[Math.floor(Math.random() * GIFTS.length)];
    sfx.click();
    setReveal(g);
    const next = [...collected, g.n];
    setCollected(next); save(next);
    setTimeout(() => sfx.win(), 150);
  };
  const unique = new Set(collected).size;

  return (
    <Modal open={open} onClose={onClose} testId="pack-modal" maxWidth="max-w-md">
      <div className="p-6 text-center">
        <h2 className="font-signboard text-2xl font-bold text-kirana-brown">🎁 Lucky Packet</h2>
        <p className="mt-1 text-sm text-kirana-brown/70">The best part was never the chips — it was the free gift inside! Open one.</p>

        <div className="my-5 flex min-h-[130px] items-center justify-center">
          {reveal ? (
            <div key={reveal.n + collected.length} className="bc-roll-in flex flex-col items-center" data-testid="pack-reveal">
              <span className="text-6xl">{reveal.e}</span>
              <span className="mt-1 font-signboard text-xl font-bold text-kirana-brown">{reveal.n}</span>
              <span className={`mt-1 rounded-full border-2 border-kirana-brown px-2 py-0.5 text-[11px] font-bold ${reveal.r === "Epic" ? "bg-kirana-gold" : reveal.r === "Rare" ? "bg-kirana-green text-white" : "bg-kirana-cream"} text-kirana-brown`}>{reveal.r}</span>
            </div>
          ) : (
            <span className="text-6xl">🎁</span>
          )}
        </div>

        <div className="flex flex-wrap justify-center gap-2">
          {PACKS.map((p) => (
            <ABtn key={p.k} data-testid={`pack-${p.k}`} onClick={openPack} tone="gold">{p.e} {p.l}</ABtn>
          ))}
        </div>
        <p className="mt-4 text-sm font-bold text-kirana-brown" data-testid="pack-count">Collected: {collected.length} gifts · {unique}/{GIFTS.length} unique</p>
      </div>
    </Modal>
  );
};
